import React from 'react';
import { connect } from 'react-redux';
import { Avatar } from '@material-ui/core';
import Api from '../../api/Api.js';
import { store } from '../../redux/store';
import { SET_USER_LIST } from '../../redux/types';
import { push } from 'connected-react-router';
import UserEndpoints from '../../api/UserEndpoints';
import UserImage from '../../components/Image/UserImage';
import DataTable from '../../components/Table/DataTable';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Logo",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Name",
        options: {
            filter: true,
            sort: true,
        }
    }
];

class SearchUsers extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/users/view/' + row[0]))
    };

    UNSAFE_componentWillMount() {
        Api.get(UserEndpoints.list).then(({ data }) => store.dispatch({ type: SET_USER_LIST, payload: data })).catch((e) => console.error(e));
    }

    render() {
        return (
                <DataTable
                    title={"Search Users"}
                    data={
                        this.props.allUsers
                        .map(usr => [usr.id, <UserImage {...usr} />, usr.name + (usr.surname ? " " + usr.surname : '')])
                    }
                    columns={columns}
                    options={this.options}
                />
        );
    }
}

const mapStateToProps = (state) => ({ allUsers: state.allUsers.list })

export default connect(mapStateToProps)(SearchUsers);